<template>
    <div class="min-h-dvh bottom-banner bottom-banner-blue-110 tw-flex tw-items-center tw-justify-center">
        <v-empty-state
            headline="Ups, 404"
            :image="LogoSVG"
            :text="$t('notFound.text')"
            :title="$t('notFound.title')"></v-empty-state>
    </div>
</template>

<script setup lang="ts">
    import LogoSVG from '@/assets/logo.svg';
    import { useI18n } from 'vue-i18n';

    const { t } = useI18n();
    document.title = t('notFound.docTitle');
</script>

<style scoped></style>
